<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle">
          <h3>{{ item.pkName }}</h3>
          <van-icon @click="$emit('delOrder', index)" name="close" />
        </div>
        <div class="methodSlidebt">
          <ul>
            <li> <h3>ICCID起始:</h3> <p>{{ item.iccidBegin }}</p> </li>
            <li> <h3>ICCID结束:</h3> <p>{{ item.iccidEnd }}</p> </li>
            <li> <h3 class="lastNum">数量:</h3> <p>{{ item.num }}</p> </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="list.length === 0" class="titless">
      暂未填写套餐
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 250px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 20px;
    .title {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .methodTitle {
        display: flex;
        justify-content: space-between;
        justify-content: center;
        align-items: center;
        h3 {
          font-size: 32px;
          color: #8585cc;
          line-height: 20px;
        }
        i {
          position: absolute;
          font-size: 40px;
          top: 12px;
          right: 12px;
          color: rgb(168, 168, 168);
        }
      }
      .methodSlidebt {
        ul {
          display: flex;
          justify-content: space-between;
          height: 100px;
          flex-direction: column;
          li {
            display: flex;
            flex-direction: row;
            h3 {
              flex: 1;
              line-height: 18px;
              font-size: 30px;
              color: #9D9DA3;
            }
            p {
              flex: 2;
              line-height: 20px;
              font-size: 30px;
              color: #272729;
            }
          }
        }
      }
    }
    .btn {
      flex: 1;
      text-align: center;
      padding-left: 45px;
      .van-button {
        width: 100px;
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-1.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .titless {
    font-size:25px;
    text-align: center;
    color: #969799;
    margin-bottom: 30px;
  }
</style>
